import { fi } from "date-fns/locale";
import {
  GET_INCIDENT_AGING_FAIL,
  GET_INCIDENT_AGING_REQUEST,
  GET_INCIDENT_AGING_SUCCESS,
  GET_INCIDENT_RESOLUTION_FAIL,
  GET_INCIDENT_RESOLUTION_FILTER_LOOKUP_SUCCESS,
  GET_INCIDENT_RESOLUTION_PROGRESS_FAIL,
  GET_INCIDENT_RESOLUTION_PROGRESS_REQUEST,
  GET_INCIDENT_RESOLUTION_PROGRESS_SUCCESS,
  GET_INCIDENT_RESOLUTION_REQUEST,
  GET_INCIDENT_RESOLUTION_SUCCESS, GET_INCIDENT_RESOLUTION_SUMMARY_FAIL, GET_INCIDENT_RESOLUTION_SUMMARY_REQUEST,
  GET_INCIDENT_RESOLUTION_SUMMARY_SUCCESS, GET_OPEN_INCIDENTS_TREND_FAIL,
  GET_OPEN_INCIDENTS_TREND_REQUEST,
  GET_OPEN_INCIDENTS_TREND_SUCCESS,
  GET_SLA_DATA_SUMMARY_FAIL,
  GET_SLA_DATA_SUMMARY_REQUEST,
  GET_SLA_DATA_SUMMARY_SUCCESS,
  GET_SLA_FILTER_LOOKUPS_FAIL,
  GET_SLA_FILTER_LOOKUPS_REQUEST,
  GET_SLA_FILTER_LOOKUPS_SUCCESS,
  TOGGLE_INCIDENT_RESOLUTION_PROGRESS_AVERAGE
} from "../actions/elements";

const initialState = {
  incidentAging: {
    loading: true,
    chart: [],
    max: null
  },
  incidentResolution: {
    loading: true,
    chart: null
  },
  incidentsTrend: {
    loading: true,
    chart: null
  },
  incidentResolutionSummary: {
    closed: null,
    openCloseRate: null,
    planVsActual: null,
    loading: true
  },
  filters: null,
  resolutionProgress: {
    loading: true,
    chart: null
  },
  slaFilterLookups: null,
  slaFiltersLoading: false,
  slaDataSummaryLoading: false,
  slaDataSummary: null,

};

export default function elements(state = initialState, action) {
  switch (action.type) {
    case GET_INCIDENT_AGING_REQUEST:
      return {
        ...state,
        incidentAging: {
          ...state.incidentAging,
          loading: true
        },
      };
    case GET_INCIDENT_AGING_SUCCESS:
      return {
        ...state,
        incidentAging: {
          loading: false,
          ...action.payload
        },

      };
    case GET_INCIDENT_AGING_FAIL:
      return {
        ...state,
        incidentAging: {
          ...state.incidentAging,
          loading: false,
        },
      };

    case GET_OPEN_INCIDENTS_TREND_REQUEST:
      return {
        ...state,
        incidentsTrend: {
          ...state.incidentsTrend,
          loading: true
        },
      };

    case GET_OPEN_INCIDENTS_TREND_SUCCESS:
      return {
        ...state,
        incidentsTrend: {
          loading: false,
          chart: action.payload
        },
      };

    case GET_OPEN_INCIDENTS_TREND_FAIL:
      return {
        ...state,
        incidentsTrend: {
          ...state.incidentsTrend,
          loading: false,
        },
      };

    case GET_INCIDENT_RESOLUTION_REQUEST:
      return {
        ...state,
        incidentResolution: {
          ...state.incidentResolution,
          loading: true
        },
      };

    case GET_INCIDENT_RESOLUTION_SUCCESS:
      return {
        ...state,
        incidentResolution: {
          loading: false,
          chart: action.payload
        },
      };

    case GET_INCIDENT_RESOLUTION_FAIL:
      return {
        ...state,
        incidentResolution: {
          ...state.incidentResolution,
          loading: false,
        },
      };

    case GET_INCIDENT_RESOLUTION_SUMMARY_REQUEST:
      return {
        ...state,
        incidentResolutionSummary: {
          ...state.incidentResolutionSummary,
          loading: true
        },
      };

    case GET_INCIDENT_RESOLUTION_SUMMARY_SUCCESS:
      return {
        ...state,
        incidentResolutionSummary: {
          ...action.payload,
          loading: false
        },
      };

    case GET_INCIDENT_RESOLUTION_SUMMARY_FAIL:
      return {
        ...state,
        incidentResolutionSummary: {
          ...state.incidentResolutionSummary,
          loading: false,
        },
      };

    case GET_INCIDENT_RESOLUTION_FILTER_LOOKUP_SUCCESS:
      return {
        ...state,
        filters: action.payload,
      };

    case GET_INCIDENT_RESOLUTION_PROGRESS_REQUEST:
      return {
        ...state,
        resolutionProgress: {
          ...state.resolutionProgress,
          loading: true
        },
      };

    case GET_INCIDENT_RESOLUTION_PROGRESS_SUCCESS:
      return {
        ...state,
        resolutionProgress: {
          loading: false,
          chart: action.payload
        },
      };

    case GET_INCIDENT_RESOLUTION_PROGRESS_FAIL:
      return {
        ...state,
        resolutionProgress: {
          ...state.resolutionProgress,
          loading: false,
        },
      };

    case TOGGLE_INCIDENT_RESOLUTION_PROGRESS_AVERAGE:
      return {
        ...state,
        resolutionProgress: {
          ...state.resolutionProgress,
          chart: {
            ...state.resolutionProgress.chart,
            datasets: [
              {
                ...state.resolutionProgress.chart.datasets[0],
                hidden: !state.resolutionProgress.chart.datasets[0].hidden
              },
              ...state.resolutionProgress.chart.datasets.slice(1)
            ]
          }
        },
      };
      case GET_SLA_FILTER_LOOKUPS_REQUEST:
        return {
          ...state,
          slaFiltersLoading: true,
        };

      case GET_SLA_FILTER_LOOKUPS_SUCCESS:
        return {
          ...state,
          slaFilterLookups: action.payload,
          slaFiltersLoading: false,
        };

      case GET_SLA_FILTER_LOOKUPS_FAIL:
        return {
          ...state,
          slaFiltersLoading: false,
        };

      case GET_SLA_DATA_SUMMARY_REQUEST:
        return {
          ...state,
          slaDataSummaryLoading: true,
        };

      case GET_SLA_DATA_SUMMARY_SUCCESS:
        return {
          ...state,
          slaDataSummary: action.payload,
          slaDataSummaryLoading: false,
        };

      
      case GET_SLA_DATA_SUMMARY_FAIL:
        return {
          ...state,
          slaDataSummaryLoading: false,
        };

    default:
      return state;
  }
}
